import React from 'react';
import { convertToSlug, getIconSrcFromSrcList } from 'globals/utils';
import iconDefaultFallbackSrc from 'assets/icons/events-feed/default-fallback.svg';
import * as IconSources from 'assets/icons/events-feed';

const iconSrcList = Object.values(IconSources);

interface FsEventsFeedIconLoaderProps {
  type?: string;
}

const FsEventsFeedIconLoader: React.FC<FsEventsFeedIconLoaderProps> = ({
  type,
}) => {
  const iconSrc = type
    ? getIconSrcFromSrcList(
        iconSrcList,
        convertToSlug(type),
        iconDefaultFallbackSrc
      )
    : iconDefaultFallbackSrc;
  return (
    <img
      src={iconSrc}
      style={{ width: 30 }}
      alt={type}
      data-test="events-feed-icon-loader"
    />
  );
};

FsEventsFeedIconLoader.displayName = 'EventsFeedIconLoader';

export default FsEventsFeedIconLoader;
